import { css, styled } from 'next-yak';
import type { ElementType, HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import type { ListVariant } from './';

type ListTransientProps = {
  $variant?: ListVariant;
};

type ListElementProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
};

const ListElement = forwardRef<HTMLElement, ListElementProps>(
  ({ as: Component = 'ul', ...props }, ref) => (
    <Component {...props} ref={ref} />
  )
);

// *** Variants ***
export const variants = {
  row: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `,
};

// *** Components ***
export const List = styled(ListElement)<ListTransientProps>`
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;

  ${({ $variant }) => {
    switch ($variant) {
      case 'row':
        return variants.row;
      default:
        return $variant satisfies undefined;
    }
  }}
`;
